import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

/**
 * Popup shown after a drag-drop on the Master Schedule grid.
 * Asks the user how to drop the source onto the target cell:
 *  - Copy        : keep the original, add a copy to the target (merged)
 *  - Swap        : exchange the two cells' contents (whole-cell drags only)
 *  - Replace Only: move here and delete the target's current content
 */
export default function DragDropPrompt({ prompt, onChoose, onCancel }) {
  if (!prompt) return null;
  const isCell = prompt.mode === "cell";
  const what = isCell ? "these classes" : `"${prompt.itemLabel}"`;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-sm" data-testid="drag-drop-prompt">
        <DialogHeader>
          <DialogTitle>Move {isCell ? "block" : "class"} to {prompt.targetLabel}</DialogTitle>
          <DialogDescription>Choose how to drop {what} onto {prompt.targetLabel}.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-1">
          <Button variant="outline" className="w-full h-auto justify-start py-2 flex-col items-start" onClick={() => onChoose("copy")} data-testid="drag-op-copy">
            <span className="font-semibold">Copy</span>
            <span className="text-xs text-muted-foreground font-normal">Keep the original and add a copy here</span>
          </Button>
          <Button variant="outline" className="w-full h-auto justify-start py-2 flex-col items-start" onClick={() => onChoose("swap")} data-testid="drag-op-swap">
            <span className="font-semibold">Swap</span>
            <span className="text-xs text-muted-foreground font-normal">{isCell ? "Exchange the two cells' contents" : "Put this class here and move what's here back to its spot"}</span>
          </Button>
          <Button variant="outline" className="w-full h-auto justify-start py-2 flex-col items-start" onClick={() => onChoose("replace")} data-testid="drag-op-replace">
            <span className="font-semibold">Replace Only</span>
            <span className="text-xs text-muted-foreground font-normal">Move here and delete what's currently in this cell</span>
          </Button>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} data-testid="drag-op-cancel">Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
